import { render, staticRenderFns } from "./pharmacistList.vue?vue&type=template&id=87db82b8&scoped=true"
import script from "./pharmacistList.vue?vue&type=script&lang=js"
export * from "./pharmacistList.vue?vue&type=script&lang=js"
import style0 from "./pharmacistList.vue?vue&type=style&index=0&id=87db82b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87db82b8",
  null
  
)

export default component.exports